<template>
    <div class="card container pk-home-panel">
        <div class="card-body">

            <div class="card container pk-home-hero">
                <div class="card-body">
                    <span style="font-size: 40px; user-select: none;">
                        <img src="@/assets/svg_icons/snake.svg" alt="">
                    </span>
                    &nbsp;
                    欢迎大家来玩啊!
                </div>
            </div>

            <div class="row container pk-mode-grid">
                <div class="col-4 container pk-mode-col">
                    <div class="card container pk-mode-card">
                        <div class="card-body match" @click="open_pk_match()">
                            <span style="font-size: 80px;">匹</span><span style="font-size: 40px;">配</span>
                        </div>
                    </div>
                </div>

                <div class="col-4 container pk-mode-col">
                    <div class=" card container pk-mode-card">
                        <div class="card-body bot" @click="open_pk_bot()">
                            <span style="font-size: 80px;">人</span><span style="font-size: 40px;">机</span>
                        </div>
                    </div>
                </div>

                <div class="col-4 container pk-mode-col">
                    <div class=" card container pk-mode-card">
                        <div class="card-body bot" @click="open_training()">
                            <span style="font-size: 80px;">训</span><span style="font-size: 40px;">练</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from '@/router/index';
import { useStore } from 'vuex';

export default {
    setup() {
        const store = useStore();

        const open_pk_match = () => {
            if (store.state.user.is_login) {
                router.push({
                    name: "pk_index",
                })
            } else {
                router.push({
                    name: 'user_account_login'
                });
            }
        }

        const open_pk_bot = () => {
            if (store.state.user.is_login) {
                router.push({
                    name: "pk_bot",
                })
            } else {
                router.push({
                    name: 'user_account_login'
                });
            }
        }

        const open_training = () => {
            router.push({
                name: "training_index",
            });
        }

        return {
            open_pk_match,
            open_pk_bot,
            open_training,
        }
    }
}
</script>

<style scoped>
.pk-home-panel {
    width: min(100%, 980px);
    margin-top: 28px;
    padding: 4px;
}

.pk-home-panel>.card-body {
    padding: 24px;
    text-align: center;
}

.pk-home-hero {
    width: 100%;
    margin: 0 auto 20px;
    background: linear-gradient(135deg, rgba(37, 99, 235, 0.14), rgba(20, 184, 166, 0.12));
    border-color: rgba(20, 184, 166, 0.28);
}

.pk-home-hero .card-body {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    min-height: 96px;
    font-size: 22px;
    font-weight: 800;
}

.pk-home-hero img {
    width: 44px;
    height: 44px;
}

.pk-mode-grid {
    width: 100%;
    margin: 0;
    padding: 0;
    row-gap: 16px;
}

.pk-mode-col {
    padding: 0 8px;
}

.pk-mode-card {
    width: 100%;
    height: 100%;
    margin: 0;
    background: var(--app-surface-strong);
    border-color: var(--app-border);
    transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.pk-mode-card:hover {
    transform: translateY(-4px);
    border-color: var(--app-accent);
    box-shadow: var(--app-shadow);
}

.match,
.bot {
    min-height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--app-text);
    font-weight: 900;
    cursor: pointer;
    user-select: none;
}

.match:hover,
.bot:hover {
    cursor: pointer;
}

@media (max-width: 768px) {
    .pk-home-panel {
        width: calc(100% - 24px);
        margin-top: 16px;
    }

    .pk-mode-col {
        width: 100%;
        flex: 0 0 100%;
        padding: 0;
    }

    .match,
    .bot {
        min-height: 118px;
    }
}
</style>
